import { render, staticRenderFns } from "./6-materials.vue?vue&type=template&id=51c90fff&scoped=true&"
import script from "./6-materials.vue?vue&type=script&lang=js&"
export * from "./6-materials.vue?vue&type=script&lang=js&"
import style0 from "./6-materials.vue?vue&type=style&index=0&id=51c90fff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c90fff",
  null
  
)

export default component.exports